export default __webpack_public_path__ + "images/GP.27b6cba.png";